'use client';

import { type SVGProps } from 'react';

export function AI2Mark(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 48.02 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            height={24}
            role="img"
            {...props}>
            <title>AI2 Mark</title>
            <path
                d="M19.2,18.73h-9.6v-9.13h7.73c1.03,0,1.87-.84,1.87-1.87V0h9.13v9.6c0,5.06-4.1,9.13-9.13,9.13ZM9.6,19.67H0v9.13h7.73c1.03,0,1.87.84,1.87,1.87v7.73h9.13v-9.6c0-5.06-4.1-9.13-9.13-9.13ZM40.3,19.2c-1.03,0-1.87-.84-1.87-1.87v-7.73h-9.13v9.6c0,5.06,4.1,9.13,9.13,9.13h9.6v-9.13h-7.73ZM19.67,38.4v9.6h9.13v-7.73c0-1.03.84-1.87,1.87-1.87h7.73v-9.13h-9.6c-5.06,0-9.13,4.1-9.13,9.13Z"
                fill="currentColor"
            />
        </svg>
    );
}
